import React, { Component } from 'react';
import { connect } from 'react-redux';
import { savedPackagesOperations } from 'state/savedPackages';
import { createPackageCards } from 'components/packageCard/PackageCardFactory';
import { POPULAR_HOTELS_PACKAGE } from 'components/packageCard/constants/packageTypes';
import PopularItems from 'components/carousel/popularItems/PopularItems';

class HotelsList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cards: [],
    };
  }

  componentDidMount() {
    this.generateCards();
  }

  generateCards() {
    const { hotels } = this.props;
    const cards = createPackageCards({
      packages: hotels,
      packageType: POPULAR_HOTELS_PACKAGE,
      configuration: {
        small: true,
        subheader: true,
        maxWidth: '742px',
        target: '_self',
        linkInterceptClassname: 'hotelCardWrap',
      },
      events: {
        onClickAddHearted: this.props.addSavedPackages,
        onClickRemoveHearted: this.props.removeSavedPackages,
      },
    });

    this.setState({
      cards,
    });
  }

  render() {
    const { cards } = this.state;

    const title = {
      id: 'frontpage.popularHotels.title',
      description: 'Popular hotels',
      defaultMessage: 'Popular hotels',
    };

    return <PopularItems title={title} items={cards} />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addSavedPackages: function (packet) {
      dispatch(savedPackagesOperations.updateSavedPackages(null, packet));
    },
    removeSavedPackages: function (id) {
      dispatch(savedPackagesOperations.updateSavedPackages(id, null));
    },
  };
}

export default connect(null, mapDispatchToProps)(HotelsList);
